/** Gemeinsame Schlüssel und Schwellwerte der Personenakte. */

/** Tab-Schlüssel der Personenakte (URL-Parameter `tab`). `document` und `documents` sind Altschreibweisen von `files`. */
export const PERSON_DETAIL_TAB_KEY = {
  contracts: "contracts",
  restPeriods: "restPeriods",
  priceAdjustments: "priceAdjustments",
  contributions: "contributions",
  wallets: "wallets",
  openItems: "openitems",
  statement: "statement",
  payments: "payments",
  articleSales: "articleSales",
  promotions: "promotions",
  files: "files",
  changes: "changes",
  legacyDocuments: "documents",
  legacyDocument: "document"
} as const;

/** Sortierposition unbekannter Tabs: hinter allen bekannten. */
export const PERSON_DETAIL_TAB_UNKNOWN_ORDER = 1000;

/** `rowKind` der Inkassoposten in Zahlungslisten. */
export const PAYMENT_ROW_KIND_DEBT_COLLECTION = "debtCollection";

/** Anzeigestatus einer Zahlung (`displayStatus` der API, ergänzt um abgeleitete Werte). */
export const PAYMENT_DISPLAY_STATUS = {
  paid: "paid",
  reversal: "reversal",
  partiallyReversed: "partially-reversed",
  reversed: "reversed",
  rebooked: "rebooked",
  cancelled: "cancelled",
  refund: "refund",
  debtCollection: "debt-collection"
} as const;

/** `cancellationType` Rückerstattung (Backend `PaymentCancellationType.Refund`). */
export const PAYMENT_CANCELLATION_TYPE_REFUND = 2;

/** Rundungstoleranz von Zahlungsbeträgen (Euro) beim Prüfen auf vollständig storniert. */
export const PAYMENT_AMOUNT_TOLERANCE = 0.0001;

/** Rundungstoleranz von Beitragsbeträgen (Euro): darunter gilt ein Betrag als null. */
export const CONTRIBUTION_AMOUNT_TOLERANCE = 0.01;

/** Wert eines als Text im Browserspeicher abgelegten Wahrheitswerts. */
export const STORED_BOOLEAN_TRUE = "true";
